import { isProdVersion } from '@stilingue/st-environment-controller-utils';

const serviceVersion = isProdVersion() ? 'prod' : 'staging';

export default serviceVersion;
